import { render } from "./Modal.vue?vue&type=template&id=de9528e0&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=de9528e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-de9528e0"

export default script